import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadCategories, deleteCategory } from '../actions/categoryActions';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FbImage from '../common/components/fb_image/FbImage';
import { adminPageRootStyle } from './styles';

const CategoriesListPage = () => {
    const dispatch = useDispatch();
    const categories = useSelector(state => state.category.categories);

    useEffect(() => {
        dispatch(loadCategories());
    }, [dispatch]);

    const handleDelete = (id) => {
        dispatch(deleteCategory(id));
    };

    return (
        <Paper style={adminPageRootStyle}>
            <h1>Categories</h1>
            <Button variant="contained" href="/admin/categories/add" sx={{ alignSelf: 'flex-start' }}>
                Add Category
            </Button>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell >Cover</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(categories ?? []).map((category) => (
                            <TableRow
                                key={category.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {category.id}
                                </TableCell>
                                <TableCell>{category.categoryName}</TableCell>
                                <TableCell>
                                    <FbImage
                                        path={category.coverThumbnailPath || category.coverPath}
                                        style={{
                                            objectFit: 'cover',
                                            width: '120px',
                                            height: '100px'
                                        }} />
                                </TableCell>
                                <TableCell align="right">
                                    <IconButton href={`/admin/categories/edit/${category.id}`}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(category.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default CategoriesListPage;
